module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "ch02"
    }
  }, [_vm._v("Chapter Two")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IMPKINSVILLE WAS NO BETTER AND NO WORSE THAN ANY")]), _vm._v(" of the other lumber towns the peddler had seen in more than a year of wandering. It was a small but noisy community, nestled close to the Columbia River and flanked by mountains thick with blue-green timber. He thought of Puget Sound and then of Wenatchee, another town on that sometimes turbulent waterway, and felt a pang of homesickness.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Tess directed him onto a side street within walking distance of the cacophonous sawmill. She was a pretty thing, with her wild cascades of rich brown hair, her impertinent nose, her wide, hazel-green eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("And she knew that he was not Joel Shiloh. Keith was "), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("sure she had seen through his hasty, awkward lie about the Bible and the name printed on its battered leather cover. Damn.")])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("He was about to turn to her and tell her who he was when she pointed out her aunt’s boardinghouse. Keith had never seen anything quite like it; it was part house and part passenger train, and the sight of it pushed every thought of confession out of his mind.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The center of the structure was an ordinary wooden building, square and unremarkable, weathered by the fierce Oregon winters and the hot sun of at least two dozen summers, but branching out from it in four directions were railroad cars, apparently serving as wings.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Tess glanced quickly at his face, and her lower lip jutted just a little, telling him that she was sensitive about the oddness of her home. “I live here,” she said, quite unnecessarily.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Keith squinted at the place, still unable to believe what he was seeing. “How—”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Tess tensed, and her stirrings had an unsettling effect on Keith Corbin. It had been too long, he guessed, since he’d had a woman.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("But he had no intention of having this one. She was innocent, sweet, and entirely too young, and even though he’d left the straight and narrow path long ago, he still had a conscience. Sometimes to his regret.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“My uncle bought the cars from the railroad, when the spur into Simpkinsville was built,” Tess explained stiffly. “He was going to have a freight line of his own.”")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("Keith drew back on the reins, and the mule, sometimes recalcitrant, came to an obedient stop. “Your uncle? You didn’t mention—”")]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("“He left my aunt two years ago, Mr. Shiloh. He ran away with another woman.” She sat still in the seat, a challenge flashing in her eyes. Probably, given the nature of small towns, she had taken considerable guff about what her uncle had done. “My aunt and I needed a way to make a living, so we had the cars brought here and we attached them to the house, so that we could take in boarders.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“I see,” said Keith, softly. Watching her, his throat suddenly felt thick, and his stomach began doing strange things. He wondered if he was coming down with something.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Tess was scrambling out of the wagon seat, an awkward undertaking, since she was wearing trousers that were about to fall off. “Thank you very much for all your help,” she said, standing ramrod straight and holding her borrowed trousers up with one hand.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Keith swallowed a laugh. God, but she was beautiful, even if she was a child, even if she was wearing his clothes instead of her own. “Don’t you want your things?” he asked, and before she could answer, he set the brake lever and jumped to the ground. The burn on his right foot stung so fiercely that he winced. That’s what you get for standing in fires when you have holes in your boots, he thought, as he rounded the wagon and opened the door at the rear.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Tess was waiting on the rickety wooden sidewalk—weeds were growing through the cracks—and casting nervous looks toward her aunt’s boardinghouse as he wrestled the bicycle out of the wagon and then reached for the camera.")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("She wheeled the bicycle a few feet away and let it rest against a picket fence in no better repair than the ")]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("sidewalk and came back for the camera. Her eyes were alight with mingled caution and fondness as she reached for the cumbersome box, and Keith wished incomprehensibly that she would look at him that way.")])]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Will you take my picture someday, Tess Bishop?” he found himself asking.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("She colored richly, averted her eyes for a moment, and then looked at him with a sort of tender defiance. “Yes, but only if you shave,” she said importantly.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("It was then that he saw the sign swinging from the roof of the boardinghouse’s narrow porch. “Lecture Tonight,” it read.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Keith rubbed his beard-stubbled chin thoughtfully. This place was getting more and more intriguing by the moment. Besides, he did need a bath and a shave, and the prospect of sleeping in a real bed had distinct appeal, after all the nights he’d spent in his wagon. “Does your aunt have any rooms to rent?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Tess stiffened and her cheeks flared, yet again, with an appealing rose color. “No—I—”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Before she could finish, the front door opened and a woman almost as tall as Keith himself came sweeping down the walkway, looking at once interested and annoyed.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Tess Bishop, where have you—” Dark eyes swept Keith’s frame, stopped at his face.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("This would have to be Derora, Tess’s aunt. Keith was taken aback, once again, for he’d expected a scarecrow or a fat curmudgeon. This woman, a few years older than himself and flawlessly beautiful, was certainly neither.")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("She smiled. “Derora Beauchamp,” she said, extending one elegant hand. Her morning gown was made of ")]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("some fluttery pink fabric, and Keith’s desire for a proper bath and a bed was redoubled by her touch.")])]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("“This is Mr. Joel Shiloh,” Tess announced, from somewhere in the shimmering fog. Then, disparagingly, she added, “He’s a peddler.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Derora Beauchamp smiled, revealing a set of perfect, pearl-like teeth. “A road-weary traveler,” she said. “Ours is the finest roominghouse in town, Mr. Shiloh. Won’t you avail yourself of the comforts we offer?”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Ours is the "), _c('em', [_vm._v("only")]), _vm._v(" roominghouse in town,” put in the hoyden at Keith’s side, grudgingly.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The warmth of Mrs. Beauchamp’s hand, resting in Keith’s, made sweet shivers run up and down his weary spine and dissipate in the aching muscles of his back. Too long. It had been too long.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("He managed to nod and sensed rather than saw the scathing look Tess flung in his direction. Little Tess. He smiled and rumpled her wind-and rain-tangled hair and allowed Derora Beauchamp to lead him down the primrose path.")]), _vm._v(" "), _c('p', {
    staticClass: "secbreak"
  }, [_vm._v("* * *")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Tess Bishop simmered as she watched her aunt usher that crazy peddler into the house. She’d make tea, Derora would. She’d offer him the best chair in the parlor and perhaps even a cigar.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Stopping before the sign proclaiming tonight’s lecture, she glared up at it. Free love. How fitting that the topic was free love!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("But it won’t be free, Mr. Joel Shiloh, she thought, with bitter satisfaction. It won’t be free.")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("Not wanting to face either Derora or her aunt’s prospective conquest, Tess walked around the house, ")]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("with its railroad-car wings, and slunk up the kitchen steps, holding the trousers in place with one hand and cradling her camera against her middle with the other.")])]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Juniper, the black woman who, with Tess’s help, cooked for the boarders, came to the screened door, with its tears and rusty places, and looked out, rolling her great round eyes so that only the whites showed. “Tess Bishop, you little scamp, what you doin’ wearin’ them clothes? Where you been?”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Tess returned the thin woman’s stare with a baleful one of her own. “Just open the door, Juniper,” she pleaded tartly. “I’ll explain later.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“You sure as the devil will,” retorted the ascerbic Juniper, but she did open the door. “Lord ha’ mercy, will you look at this chile—hair flyin’ like a Jezebel’s—wearin’ pants—”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Oh, hush!” hissed Tess, embarrassed and curious beyond bearing about what might be taking place in Derora’s overdecorated parlor. What did she care if her aunt seduced that maniac, anyway? It would serve him right.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("But she did care. Oh, she did. Tears brimmed in Tess’s eyes as she remembered the way Joel Shiloh had looked at her aunt. He’d forgotten that Tess was even there, except to reach out and ruffle her hair, as though she were a gawky child.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“You get to your room and put on somethin’ decent!” ordered Juniper, turning to an enormous bowl of batter and stirring furiously. “I swear I ain’t never seen such a chile—”")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("“I’m not a child!” Tess shouted, and then she hurried across the kitchen, through the small dining room, and ")]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("up the stairs to the second floor. As fast as she moved, she couldn’t help hearing Derora’s sensual, throaty laughter and the masculine timbre of Joel’s.")])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("In her small room, she put her camera carefully onto the bureau top and began tearing Joel Shiloh’s clothes off her body as though they were on fire. Damn him, damn Derora. Damn the whole world!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The idea dawned, glowing and ignoble, as she was putting on her best satin camisole. The lecture! Of course! Tess Bishop was no child, and by George, she’d prove it. She would attend that lecture and she would listen as she had never listened before. And then she would adopt the philosophy of free love. Who could call her a child then?")]), _vm._v(" "), _c('p', {
    staticClass: "secbreak"
  }, [_vm._v("* * *")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The water was gloriously hot, and Keith Corbin sank into it with a sigh of contentment, a cigar clenched between his teeth, his burned foot propped comfortably on the edge of the tub. This, indeed, was the life. All he needed now was a drink and a woman, and if he’d read the promises in Derora Beauchamp’s gypsy eyes correctly, he wouldn’t have to wait long for either.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("He shifted in the metal tub so that the water covered his aching shoulders and, with his teeth, tilted his cigar at a jaunty upright angle. “I knew a girl in Tillamachuck,” he sang around it, under his breath. “She couldn’t dance but she could—”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Just then, the door of Derora Beauchamp’s well-equipped bathroom swung open. The little devil, thought Keith, with a grin.")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("His cigar fell into the bathwater when Tess peered around the corner. “Oh, sorry,” she said, and she turned the color of watermelon pulp.")]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Keith slid downward until the water covered his head, his strangled curses bubbling to the top. When he surfaced the door was closed, and Tess, of course, was gone. He fished his ruined cigar out and flung it against the wall.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Maybe he wouldn’t take his pleasure with Derora after all, if Tess was going to be peeping around doors all the time. Hell, he’d find a brothel, a place where a man could buy a drink and be assured of some privacy.")]), _vm._v(" "), _c('p', {
    staticClass: "secbreak"
  }, [_vm._v("* * *")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Make up the bed in the west wing,” Derora said coldly, her eyes never quite meeting Tess’s. She took a chocolate from the box beside her chair and nibbled at it with her elegant teeth.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The west wing. Tess would have laughed if she’d dared; since when did a converted passenger car qualify as a wing? “Yes, ma’am,” she said sweetly. “The front part of the car?”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Derora flung her a scathing look. “Certainly not. The room at the rear.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Tess bit her lower lip. Her stomach was still quivering from her scandalous encounter with Joel Shiloh, only minutes before, in the upstairs bathroom. She hoped the crimson blush had faded from her face. “Mr. Wilcox is in that room,” she pointed out.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“That sweaty millworker,” said Derora dismissively. “Yes. Well, just move his things. I want Mr. Shiloh to have the room at the back.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("That way, Tess reasoned bitterly, Mr. Wilcox wouldn’t walk through and see his landlady cavorting with the new tenant. “But—”")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("“Tess, just obey me. For once, just do as I tell you. And don’t think I’m going to let that little matter of ")]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("your coming home in a man’s clothes pass unchallenged, either.”")])]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("“I’m—”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“If you tell me that you’re eighteen, Tess, I swear by all that’s holy that I’ll snatch you baldheaded. A young lady does not comport herself in that manner, no matter what her age.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“I was caught in the rain, that’s all. And my bicycle wheel was bent. Mr. Shiloh merely—”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Derora’s gaze was on the ceiling now, and her lush lips curved into an anticipatory smile. She took another chocolate and ate it in a fashion that Tess found oddly indelicate. “Mr. Shiloh presented no danger to you, I’m sure. It would be my guess that he takes little note of bounding schoolgirls with their hair tumbling down their backs.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Schoolgirls!” Tess protested. “I’m not—”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Tess, really.” Derora, who prized her figure, put the lid back on the candy box, not even looking at her niece. “Just go and do as I told you, please. And after that, I’d like you to help Jumper with tonight’s refreshments. We’re expecting a number of women to attend the lecture.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Tess sighed. She wondered what her aunt would say if she knew that her dear niece planned to attend, also. “Has Mrs. Hollinghouse-Stone arrived yet?” she asked, poised in the fringed parlor doorway.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“She has,” replied Derora crisply, smoothing her sateen skirts. “That tiresome sheriff is forcing her to apply for a permit to address us. Can you believe it? And in a country where free speech is so prized.”")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("Simpkinsville, for all its brothels and saloons, had a conservative quarter. A certain segment of its popula")]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("tion didn’t take kindly to some of the lectures that took place in Mrs. Derora Beauchamp’s front parlor. They hadn’t minded the spiritualist, though, or the round, earnest little man who had demonstrated the dying art of phrenology. Tess grinned, patting her hair, which she had carefully pinned atop her head in order to look more grown up.")])]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("She supposed free love was quite a different kettle of fish from summoning the dear departed—to her great disappointment, none of that elusive group had shown up—or determining someone’s most intimate nature by feeling the bumps on their head.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Yes, indeed, she thought, as she made her way into the “west wing,” there was an interesting night ahead.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Mr. Wilcox had few belongings, fortunately, just a Bible and a shaving kit and a “bindle,” the bedroll carried by all itinerant timber workers. Tess moved all these things into the front part of the car, which had been partitioned off from the rear, hoping that he wouldn’t mind too much. Though Derora had been quite correct in referring to Arthur Wilcox as a “sweaty millworker,” he was still a very nice man, quiet and polite. He’d paid Tess two dollars to take his likeness with her camera and then mailed the sepia-tinted result back East, to a girl he hoped to marry.")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("Tess smiled, stripping the sheets from his bed, remembering the shy, delighted way he’d posed. It was a shame to put him out like this, and all for a drummer who didn’t have any more sense than to stand in campfires and leap into creeks when he didn’t know how deep they were. Her smile faded and she worked with hasty, angry motions, putting fresh linen onto the bed that would be Joel Shiloh’s.")]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("That done, she dusted swiftly. She’d been very late getting back, thanks to that broken bicycle wheel and the rainstorm, and Juniper would be working herself into a state in the kitchen, trying to get dinner and prepare refreshments for the lecture guests as well.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In the hallway, still lined with windows although the train seats had, of course, been removed, she encountered Joel. He smelled of soap and cigar smoke, and his clothes were clean, his hair neatly brushed. He had even shaved.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Tess meant to scurry past him but instead she stopped cold, her stomach and heart waltzing with each other, forcing the breath from her lungs as they twirled, entwined.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Are you planning to attend tonight’s lecture?” she heard herself ask, with a dignity she wouldn’t have thought she could manage.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("His wonderful, arrogant mouth lifted at one side, in a half-grin. “To hear of the wonders of free love? Not hardly.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Mrs. Hollinghouse-Stone is a fine speaker,” Tess said, in lofty reply. “She was here last month. She spoke about suffrage—”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("That wry, partial grin lingered, spreading to his eyes. “A subject dear to my mother’s heart,” he said quietly. “Not to mention those of my renegade sisters-in-law.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Tess wanted to ask about his mother and his sistersin-law, about his entire family, but she didn’t dare. She’d already learned that the topic was off limits. Besides, her throat was so tight that she couldn’t have gotten a word past it anyway.")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("“Do you believe women should vote, Miss Bishop?” ")]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("he teased, his voice deep and quiet, his powerful body awakening, by its very nearness, something that had slept secretly within Tess.")])]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("She stepped back. “Yes,” she managed to reply.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“And free love? Do you practice that?”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Tess’s heart spun out of its dance with her stomach and careened off her windpipe. “Of course,” she lied, in a very shaky voice. How was she going to get past Joel Shiloh, in this dratted, narrow hallway, without touching him?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("He looked surprised and more than a little angry; in fact, some of the color drained away from beneath his tan. “You’re not serious?” he breathed.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Tess drew a deep breath. In for a penny, in for a pound, she thought. She tried to remember what her aunt had said, at dinner the night before, about the philosophy in question. “Oh, yes,” she said, feeling worldly. “How can there be wars if everyone—if everyone—”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("He folded his arms, arched one dark-gold eyebrow, and waited.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“If everyone loves each other,” she finished, with breathless triumph.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Love takes many different forms,” Joel pointed out, and he looked very displeased. “Are we talking about the same expression of that worthy emotion, Miss Bishop?”")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("Tess wanted to die, but she couldn’t back out now or she would look the fool. She would again be a child in this man’s eyes, and she couldn’t bear that. She squared her shoulders and lifted her chin. “I believe we are, Mr. Shiloh.”")]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("“In that case, I ought to take you across my knee,” came the infuriating response. And he made no move to step out of the way, so that she could pass.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“I invite you to try, Mr. Shiloh,” she replied, with cold politeness. “If you do, I promise to bite off part of your thigh while you’re at it.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("He threw back his head and shouted with laughter, and Tess jumped, startled.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“P-Please,” she said, when her racing heartbeat had settled to a pace that allowed her to speak. “Let me by. I must help Juniper with supper and the refreshments—”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("He stepped aside then, his broad chest still shaking with amusement, but when she tried to squeeze by him, he suddenly shifted his weight, trapping her against the windows of the converted railroad car. Her breasts were crushed against him, and suddenly it seemed that her insides were melting down to form a throbbing pool in the depths of her femininity.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Mr. Shiloh—” she whispered, half in protest and half in pleasure. So this was what it was like, the weight of a man’s body! What a frightening, delightful pressure it was.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("His hands rose to cup her face and tilt it upward and her hair, hastily pinned, fell about her shoulders in gleaming brown cascades. His mouth came tentatively to her own, tasting and nibbling and then, with breathtaking swiftness, devouring.")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("Tess responded as instinct commanded, letting his lips mold hers, parting them for the tender and then fierce conquering of his tongue. She had been kissed once before, behind the bandstand at the Independence ")]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("Day picnic, but it certainly hadn’t been anything like this . . .")])]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("As suddenly as he had taken her, Joel Shiloh thrust her away. His jawline was tight with annoyance, and the brisk swat of his left hand stung Tess’s pride more than her derriere.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("She glared up at him for a moment, insulted and hurt, and then stooped to gather up her hairpins, which lay on the floor of the passageway.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Tess was so angry that tears burned in her eyes, making it next to impossible to find her hair pins. And he was just standing there, so tall and imperious, too self-important to help her.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Her bottom still stung where he had swatted her. The nerve … the gall of him . . .")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Before she realized what she was doing, Tess lunged forward and sank her teeth into his left thigh. He howled in surprise and pain, and Tess let him go, scrambled to her feet, and ran down the passageway as fast as she could go.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("He caught her easily, and she thought her heart would stop beating when his hand closed over her shoulder, tight as a vice, and swung her around. It did not occur to her to scream.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“You little—” he began, his azure eyes flashing with some dangerous emotion.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“I told you I would bite you and I did!” Tess blurted out, in a hissing rush. “I am not a child and I will not be treated as one!”")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("Though he was struggling against it, a grin was tugging at one corner of his mouth. “No,” he said hoarsely. “You are not a child.”")]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Tess smoothed her skirts and her dignity. “Then you’re sorry for striking me,” she assumed.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“I didn’t say that.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Tess was maddened. “Why, you—”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“I can’t believe you seriously expect an apology,” he broke in, in an evil undertone, “when you bit me like that.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“I bit you after you struck me!”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“A minor point, Miss Bishop. Now get out of here before I lose my temper!”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("More than happy to comply, Tess turned and swept away in high dudgeon, chin up, shoulders back.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In the kitchen, Juniper was prattling as usual, but Tess barely heard her. All she could think about was that drummer and the way he’d pressed his body to hers, the way he’d kissed her. And the way he’d thrust her away, as if in disgust, and then swatted her! What reason had he had for doing that?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Peeling carrots with swift strokes of a paring knife, Tess blushed to remember the way she had bitten him. The way he’d howled.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Stop that right now afore you cut yourself!” snapped Juniper, grasping Tess’s hand and staying the motion of the paring knife. “What’s the matter with you, girl?”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Unaccountable tears sprang up in Tess’s eyes and flowed down her face, dropping off into the fragrant curls of carrot peelings. She had bitten that man, "), _c('em', [_vm._v("bitten")]), _vm._v(" him. Like an animal. “I don’t know, Juniper,” she wailed. “I don’t know!”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("For all of the older woman’s complaining, Juniper loved Tess, and she lifted a practiced hand to the young woman’s forehead to check for fever.")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("“You’s a little warm,” she fretted.")])]), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Tess was warm, all right, but not because of any fever. Thanks to that scandalous scene with Joel Shiloh, in the passageway, she felt like a candle left too close to a stove.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“I’m all right, Juniper,” she insisted, sniffling a little and trying to brush away her tears with an anxious motion of one hand. “Honestly, I am.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Juniper was not easily convinced. “It ain’t that time, is it? If it’s your misery, girl, you just get yourself off to bed and—”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("It was a misery, all right, but not the kind that Juniper was suggesting. “It isn’t that,” Tess declared, taking up the carrot she had been slashing at and peeling it in a way meant to suggest that she was competent to handle a knife.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Reluctantly, Juniper let the subject drop and went back to her own work, which was considerable.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("At dinner, Mr. Wilcox was in attendance, along with Miss Shaeffer, the schoolteacher, and Mr. Johnston, the bookkeeper at the mill. Mrs. Hollinghouse-Stone, a reed-thin woman with a wart jutting out of her one long eyebrow and a wig that had seen better days, sat in the place of honor, beside Derora. Mr. Joel Shiloh was nowhere in sight, which was just as well, as far as Tess was concerned.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Maybe he’d thought better of taking a room in Simpkinsville, maybe he’d gotten back in his wagon and driven away, never to be seen—or bitten—again.")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("Tess pushed her boiled carrots around her plate with the prongs of her fork, miserable in a way that was completely new to her. Lord knew, she’d known misery when her mother had drifted into quiet madness, ")]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("misery when her letters to her father had gone unanswered, misery when she had realized that Derora Beauchamp, her mother’s only sister, would tolerate her but never love her. But this was something different, this feeling she had now, had had since meeting Joel Shiloh that morning. It was a sweet, piercing sort of anguish and she knew instinctively that the malady was going to get considerably worse before it got better.")])]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("If it ever got better.")]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34b311c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/004.vue
// module id = 69
// module chunks = 0